jQuery(document).ready(function () {
  function runWhenIdle(callback) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if ("requestIdleCallback" in window) {
      requestIdleCallback(callback, { timeout: 2500 });
    } else {
      setTimeout(callback, 1);
    }
  }

  runWhenIdle(initZoomOutOnScroll);
});

function initZoomOutOnScroll() {
  const activeContainers = new Set();
  let rafId = null;

  function getMaxScale(container) {
    const raw = getComputedStyle(container)
      .getPropertyValue("--zoom-out-scroll-max-scale")
      .trim();

    const parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 1.25;
  }

  function getScale(container) {
    const maxScale = getMaxScale(container);

    if (!container.classList.contains("s-animation-trigger")) {
      return maxScale;
    }

    const rect = container.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const height = rect.height;

    if (!height) return maxScale;

    // 0 when the section top is at the viewport bottom; 1 when the section
    // bottom reaches the viewport top (almost fully scrolled past).
    const scrolled = viewportHeight - rect.top;
    const total = viewportHeight + height;
    const progress = Math.min(1, Math.max(0, scrolled / total));

    return maxScale - (maxScale - 1) * progress;
  }

  function updateContainer(container) {
    const img = container.querySelector("img");
    if (!img) return;

    const scale = getScale(container);
    img.style.transform = `scale(${scale})`;
  }

  function tick() {
    rafId = null;
    activeContainers.forEach(updateContainer);
  }

  function requestTick() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(tick);
  }

  function watchContainer(container) {
    if (container.dataset.zoomOutScrollWatching) return;

    container.dataset.zoomOutScrollWatching = "true";
    activeContainers.add(container);

    const classObserver = new MutationObserver(requestTick);
    classObserver.observe(container, {
      attributes: true,
      attributeFilter: ["class"],
    });

    const img = container.querySelector("img");
    if (img && !img.complete) {
      img.addEventListener("load", requestTick, { once: true });
    }

    requestTick();
  }

  document
    .querySelectorAll(".anim-zoom-out-on-scroll")
    .forEach(watchContainer);

  window.addEventListener("scroll", requestTick, { passive: true });
  window.addEventListener("resize", requestTick, { passive: true });
}
